const noAuthPaths = ['/order', '/moremenu', '/newsfeed'];

function NeedLogin(path) {
  if (path === '/' || path === '') return false;

  let response = true;

  for (let freePath of noAuthPaths) {
    if (path.includes(freePath)) response = false;
  }

  return response;
}

export default NeedLogin;
